import Navbar from '../../components/navbar/navbar.vue'

export default {
  name: 'NotFound',
  data() {
    return {};
  },
  components: {
    'navbar': Navbar,
  },
};
